module.exports = __webpack_public_path__ + "media/images/escape_to_school_ef_link/wording-pc-3890b60ecbee0cc09faad90161f38600.svg";